import qs from 'qs'

import { HttpService, HttpServiceResponse } from '../shared'
import {
  ActionEndpoints,
  ViewActions,
  ReportingOperActions,
  ViewCollmanServerData,
  AddToFavouritesParams,
  RemoveFromFavouritesParams,
  GenerateParams,
  ReportsViewParams,
  ReportsViewServerData,
  ReportingTypes,
  PrintReportingParams,
} from './reporting.types'

export class ReportingProvider {
  constructor(private http: HttpService, private baseUrl: string) {}

  public view(): Promise<HttpServiceResponse<unknown>> {
    const queryString = qs.stringify({
      action: ViewActions.VIEW,
    })

    return this.http.post(`${this.baseUrl}/${ActionEndpoints.VIEW}?${queryString}`)
  }

  public viewCollman(): Promise<HttpServiceResponse<ViewCollmanServerData>> {
    const queryString = qs.stringify({
      action: ViewActions.VIEWCOLLMAN,
    })

    return this.http.post(`${this.baseUrl}/${ActionEndpoints.VIEW}?${queryString}`)
  }

  public viewLoan(): Promise<HttpServiceResponse<unknown>> {
    const queryString = qs.stringify({
      action: ViewActions.VIEWLOAN,
    })

    return this.http.post(`${this.baseUrl}/${ActionEndpoints.VIEW}?${queryString}`)
  }

  public viewApplication(): Promise<HttpServiceResponse<unknown>> {
    const queryString = qs.stringify({
      action: ViewActions.VIEWAPPLICATION,
    })

    return this.http.post(`${this.baseUrl}/${ActionEndpoints.VIEW}?${queryString}`)
  }

  public viewCollateral(): Promise<HttpServiceResponse<unknown>> {
    const queryString = qs.stringify({
      action: ViewActions.VIEWCOLLATERAL,
    })

    return this.http.post(`${this.baseUrl}/${ActionEndpoints.VIEW}?${queryString}`)
  }

  public viewClient(): Promise<HttpServiceResponse<unknown>> {
    const queryString = qs.stringify({
      action: ViewActions.VIEWCLIENT,
    })

    return this.http.post(`${this.baseUrl}/${ActionEndpoints.VIEW}?${queryString}`)
  }

  public printReport(params: PrintReportingParams): Promise<HttpServiceResponse<unknown>> {
    const queryString = qs.stringify({
      ...params,
      action: ViewActions.PRINT,
    })

    return this.http.post(`${this.baseUrl}/${ActionEndpoints.VIEW}?${queryString}`)
  }

  public addToFavourites(params: AddToFavouritesParams): Promise<HttpServiceResponse<void>> {
    const queryString = qs.stringify({
      action: ReportingOperActions.ADDTOFAVOURITES,
      ...params,
    })

    return this.http.post(`${this.baseUrl}/${ActionEndpoints.OPER}?${queryString}`)
  }

  public removeFromFavourites(params: RemoveFromFavouritesParams): Promise<HttpServiceResponse<void>> {
    const queryString = qs.stringify({
      action: ReportingOperActions.REMOVEFROMFAVOURITES,
      ...params,
    })

    return this.http.post(`${this.baseUrl}/${ActionEndpoints.OPER}?${queryString}`)
  }

  public generate<ReportingType extends ReportingTypes>(
    params: GenerateParams<ReportingType>,
  ): Promise<HttpServiceResponse<any>> {
    const queryString = qs.stringify({
      ...params,
    })

    return this.http.post(`${this.baseUrl}/${ActionEndpoints.SQLREPORT2}?${queryString}`)
  }

  public reportsView(params: ReportsViewParams): Promise<HttpServiceResponse<ReportsViewServerData>> {
    const queryString = qs.stringify({
      ...params,
    })

    return this.http.post(`${this.baseUrl}/${ActionEndpoints.SQLREPORT2_VIEW}?${queryString}`)
  }
}
